/**
 * Busy event content renderer for the manual calendar.
 * Shows interviewer busy time blocks with the event subject.
 * Supports click-to-override: clicking on a busy block creates a slot there.
 *
 * Ref: KInterviewScheduler/.../BusyEventContent.tsx
 */
import { getEventPadding, calcDurationMinutes } from './eventHelpers';

interface BusyEventContentProps {
  title?: string;
  start: string;
  end: string;
}

export const BusyEventContent = ({
  title,
  start,
  end,
}: BusyEventContentProps) => {
  const duration = calcDurationMinutes(start, end);
  const padding = getEventPadding(duration);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        padding,
        overflow: 'hidden',
        cursor: 'pointer',
      }}
    >
      {title && (
        <div
          style={{
            fontSize: '11px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'inherit',
          }}
        >
          {title}
        </div>
      )}
    </div>
  );
};
